import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { FaTimesCircle, FaRedo, FaHome } from "react-icons/fa";
import { registrationService, giftVoucherService } from "../services/firebase";
import "./PaymentFailed.css";
import RightArrow from "assets/icone/RightArrow";
import RightArrowMoblie from "assets/icone/RightArrowMoblie";
import PrimaryButton from "components/PrimaryButton";
import RefresIcon from "assets/icone/RefresIcon";

// Component for responsive RightArrow
const ResponsiveRightArrow: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth >= 390 && window.innerWidth <= 809);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return isMobile ? <RightArrowMoblie /> : <RightArrow />;
};

const PaymentFailed: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [registration, setRegistration] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [paymentData, setPaymentData] = useState<any>(null);
  const [voucher, setVoucher] = useState<any>(null);
  useEffect(() => {
    window.scrollTo(0, 0);

    // Check if we're inside an iframe and redirect to top level
    if (window.self !== window.top && window.top) {
            window.top.location.href = window.location.href;
      return;
    }

    const loadPaymentData = async () => {
      try {
        const voucherId =
          searchParams.get("voucherId") ||
          new URLSearchParams(window.location.search).get("voucherId");
        const registrationId =
          searchParams.get("registrationId") ||
          new URLSearchParams(window.location.search).get("registrationId");

        
        if (voucherId && !registrationId) {
          try {
            const voucherData = await giftVoucherService.getById(voucherId);
            setVoucher(voucherData);
            await giftVoucherService.updatePaymentStatus(
              voucherId,
              "failed",
              searchParams.get("transaction_id") ||
                searchParams.get("TranzilaTranzilaMP") ||
                undefined
            );
          } catch (error) {
                      }
        } else if (registrationId) {
          
          const data = await registrationService.getById(registrationId);
          setRegistration(data);

          await registrationService.updatePaymentStatus(
            registrationId,
            "failed",
            searchParams.get("transaction_id") || "Tranzila_" + Date.now()
          );
        }

        const transactionId =
          searchParams.get("transaction_id") ||
          searchParams.get("TranzilaTranzilaMP") ||
          t("unavailable");
        const amount =
          searchParams.get("sum") ||
          searchParams.get("TranzilaSum") ||
          (voucher ? String(voucher.amountPaid) : t("unavailable"));

        setPaymentData({
          transactionId,
          amount,
          currency: searchParams.get("currency") || "ILS",
          status: "failed",
        });

              } catch (error) {
              } finally {
        setLoading(false);
      }
    };

    loadPaymentData();
  }, [searchParams]);
    const handleRetryPayment = () => {
    if (voucher?.id) {
      window.location.href = `/voucher-payment/${voucher.id}`;
      return;
    }
    if (registration) {
      window.location.href = `/payment/${registration.id}`;
    }
  };

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading-spinner">
          <FaTimesCircle className="fa-spin" size={40} />
          <p>{t("processing")}...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-failed-container" data-language={i18n.language}>
      <Link className="back-button-payment-failed" to="/">
        <div className="back-button-payment-failed-icon">
          <ResponsiveRightArrow />
        </div>
        {t("backToHome")}
      </Link>
      <div className="failed-header">
        <h1 className="failed-title">{t("paymentFailed")}</h1>
        <p className="failed-message">{t("paymentFailedMessage")}</p>
      </div>

      <div className="page-payment-details">
        <h3>{t("paymentDetails")}</h3>
        <div className="page-payment-info">
          <div className="page-payment-item">
            <span className="page-payment-item-text-bold">
              {t("transactionId")} : {""}
            </span>
            <span className="page-payment-item-text">
              {registration?.transactionId ||
                paymentData?.transactionId ||
                t("unavailable")}
            </span>
          </div>
          <div className="page-payment-item">
            <span className="page-payment-item-text-bold">{t("amount")} :</span>
            <span className="page-payment-item-text">
              {registration?.totalAmount
                ? `₪${registration.totalAmount}`
                : voucher?.amountPaid
                ? `₪${voucher.amountPaid}`
                : paymentData?.amount !== t("unavailable")
                ? `₪${paymentData.amount}`
                : t("unavailable")}
            </span>
          </div>
          <div className="page-payment-item">
            <span className="page-payment-item-text-bold">
              {t("status")} : {""}
              <span className="page-payment-item-text error">
                {t("failed")}
              </span>
            </span>
          </div>
          <div className="page-payment-item">
            <span className="page-payment-item-text-bold">
              {t("errorDetails")} : {""}
              <span className="page-payment-item-text error">
                {paymentData?.errorMessage || t("errorDetailsMessage")}
              </span>
            </span>
          </div>
          <PrimaryButton
            className="retry-buttonn"
            onClick={() => {
              if (voucher?.id) {
                handleRetryPayment();
                return;
              }
              navigate("/");
            }}
            fullWidth={true}
            icon={<RefresIcon />}
            iconPosition="left"
          >
            {t("retryPayment")}
          </PrimaryButton>
        </div>
      </div>

      <div className="help-section">
        <h3>{t("needHelp")}</h3>
        <p>{t("needHelpMessage")}</p>
      </div>
    </div>
  );
};

export default PaymentFailed;
